import moment from 'moment'
import Vue from 'vue'

Vue.filter('moeda', function (value) {
	var lg = JSON.parse(localStorage.getItem('__POLICE_SESSION_LG_'))
	return Number(value).moeda(2, lg.sifrao + ' ', lg.milhar, lg.decimal)
})

Vue.filter('tempoParaDecimal', function (value) {
	if (_.isNil(value)) {
		return ''
	}

	let $minutes = value.split(':')[1]
	let $hours = Number(value.split(':')[0])

	var $decimo_hora = 0

	if ($minutes >= 4 && $minutes <= 9) {
		$decimo_hora = 1
	} else if ($minutes >= 10 && $minutes <= 15) {
		$decimo_hora = 2
	} else if ($minutes >= 16 && $minutes <= 21) {
		$decimo_hora = 3
	} else if ($minutes >= 22 && $minutes <= 27) {
		$decimo_hora = 4
	} else if ($minutes >= 28 && $minutes <= 33) {
		$decimo_hora = 5
	} else if ($minutes >= 34 && $minutes <= 39) {
		$decimo_hora = 6
	} else if ($minutes >= 40 && $minutes <= 45) {
		$decimo_hora = 7
	} else if ($minutes >= 46 && $minutes <= 51) {
		$decimo_hora = 8
	} else if ($minutes >= 52 && $minutes <= 57) {
		$decimo_hora = 9
	} else if ($minutes >= 58) {
		$decimo_hora = 0
		$hours++
	} else if ($hours != 0) {
		$decimo_hora = 0
	} else {
		$decimo_hora = 0
	}

	return Number($hours) + '.' + $decimo_hora
})

Vue.filter('highlight', function(words, query){
    var iQuery = new RegExp(query, "ig");
    return words.toString().replace(iQuery, function(matchedTxt,a,b){
        return ('<span class=\'highlight\'>' + matchedTxt + '</span>');
    });
});

Vue.filter('apPmTo24', function(value){

    if(!_.isNil(value) && value != null && value != 'N/A' && value != ""){
        var time= value +''.toUpperCase();

        var hours = Number(time.match(/^(\d+)/)[1]);
        var minutes = Number(time.match(/:(\d+)/)[1]);
        var AMPM = time.match(/\s(.*)$/)[1].toLowerCase();

        if (AMPM == "pm" && hours < 12) hours = hours + 12 ;
        if (AMPM == "am" && hours == 12) hours = hours - 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;

        return sHours +':'+sMinutes;
    }

    return ''
})

Vue.filter('decimalToHora', function(value){

    if(_.isNil(value)){
        return '0'
    }
    return value.replace(".", ":")
});

Vue.filter('adicionaMN', function(value) {
    if(value > 0) {
        return value + ' MN'
    }
    return 'N/A'
});

Vue.filter('arredondar1', function(value){

    if(Number(value) == 0) {
        return ''
    }

    return parseFloat(value).toFixed(1)

})

Vue.filter('arredondar2', function(value){

    if(Number(value) == 0) {
        return ''
    }

    if(value == 'N/A'){
        return 0
    }

    return parseFloat(value).toFixed(1)

})

Vue.filter('arredondar', function(value){

    if(Number(value) == 0) {
        return ''
    }

    return parseFloat(value).toFixed(0)

})

Vue.filter('proa', function(value){

    if(Number(value) == 0) {
        return ''
    }

    return Math.round(value)

})

Vue.filter('capitalizeFirst', (value) => {
    return (value || '').toString().charAt(0).toUpperCase() + value.slice(1).toLowerCase();
})

Vue.filter('capitalize', function (value) {
    if (!value) return ''
    return value.replace(/\b\w/g, function(char) {
      return char.toUpperCase();
    });
  })

Vue.filter('decimalEmTempo', function(value){

    if(_.isNil(value)){
        return '0'
    }
    var t = parseFloat(value).toFixed(2).toString().split(".")
    if(t[1] > 0){

        if (t[1] >= 60) {
            t[0] = Number(t[0]) + 1;
            t[1] = Number(t[1]) - 60
        }

        if(t[1] > 0){
            t[1] = (t[1] / 100 * 60)
        }
    }

    return t[0].toString().padStart(2, 0) + ':' + Math.floor(t[1]).toString().padStart(2, 0)
});

Vue.filter('decimalEmTempo2', function(value) {
	if (isNaN(value) || value < 0) {
		return 'Formato inválido';
	}
    
	const horas = Math.floor(value);
	const minutos = Math.round((value - horas) * 60);

	const horasFormatadas = horas < 10 ? '0' + horas : horas;
	const minutosFormatados = minutos < 10 ? '0' + minutos : minutos;

	return `${horasFormatadas}:${minutosFormatados}`;
});

Vue.filter('data', function(value){
    const data = new Date(value)
    const verificaData = data instanceof Date && !isNaN(data)

    if(value == "" || value == null || _.isNil(value) || !verificaData){
        return "N/A"
    }

    if($sessao.getDateFormat() == "DD/MM/YYYY"){
        var dt = value.split("-")
        return (dt[2] + "/" + dt[1] + "/" + dt[0])
    }

    if($sessao.getDateFormat() == "MM/DD/YYYY"){
        var dt = value.split("-")
        return (dt[1] + "/" + dt[2] + "/" + dt[0])
    }
});

Vue.filter('data2', function(value) {
	if (!value || value === "" || _.isNil(value)) {
		return "N/A";
	}
	const data = new Date(value);
	const verificaData = data instanceof Date && !isNaN(data);
	if (!verificaData) {
		return "N/A";
	}
	const formato = $sessao.getDateFormat();
	const dia = String(data.getUTCDate()).padStart(2, '0');
	const mes = String(data.getUTCMonth() + 1).padStart(2, '0'); 
	const ano = data.getUTCFullYear();
	if (formato === "DD/MM/YYYY") {
		return `${dia}/${mes}/${ano}`;
	}
	if (formato === "MM/DD/YYYY") {
		return `${mes}/${dia}/${ano}`;
	}
	return "N/A";
});

Vue.filter('dataTempo', function(value){

    if(value == "" || value == null || _.isNil(value)){
        return "N/A"
    }

    if($sessao.getDateFormat() == "DD/MM/YYYY"){
        var dt = value.split(" ")
        return (dt[0].split("-")[2] + "/" + dt[0].split("-")[1] + "/" + dt[0].split("-")[0] +" "+ dt[1].split(':')[0] + ':' + dt[1].split(':')[1])
    }

    if($sessao.getDateFormat() == "MM/DD/YYYY"){
        var dt = value.split(" ")
        return (dt[0].split("-")[1] + "/" + dt[0].split("-")[2] + "/" + dt[0].split("-")[0] +" "+ dt[1].split(':')[0] + ':' + dt[1].split(':')[1])

    }
});

Vue.filter('tempo', function(value){

    if(value == "" || value == null || _.isNil(value)){
        return ""
    }
    var dt = value.split(' ')[1]
    var ht = dt.split(':')
    return ht[0] +':'+ht[1]
});


Vue.filter('dataSemTempo', function(value){

    if(value == "" || value == null || _.isNil(value)){
        return "N/A"
    }

    if($sessao.getDateFormat() == "DD/MM/YYYY"){
        var dt = value.split(" ")
        return (dt[0].split("-")[2] + "/" + dt[0].split("-")[1] + "/" + dt[0].split("-")[0])
    }

    if($sessao.getDateFormat() == "MM/DD/YYYY"){
        var dt = value.split(" ")
        return (dt[0].split("-")[1] + "/" + dt[0].split("-")[2] + "/" + dt[0].split("-")[0])

    }
});

Vue.filter('decimal', function(value){

    var lg = JSON.parse(localStorage.getItem("__POLICE_SESSION_LG_"));
    return Number(value).moeda(1, '', lg.milhar, lg.decimal);

});

Vue.filter('na', function(item){

    if(_.isNil(item) || item == ''){
        return 'N/A'
    }

    return item
});

Vue.filter('moeda1', function(value){

    var lg = JSON.parse(localStorage.getItem("__POLICE_SESSION_LG_"));
    return Number(value).toFixed(1).moeda(1, '', lg.milhar, lg.decimal);

});

Vue.filter('moeda', function(value){

    var lg = JSON.parse(localStorage.getItem("__POLICE_SESSION_LG_"));
    return lg.sifrao +' '+ Number(value).toFixed(2).moeda(2, '', lg.milhar, lg.decimal);

});

Vue.filter('moedaCombustivel', function(value){

    var lg = JSON.parse(localStorage.getItem("__POLICE_SESSION_LG_"));
    return lg.sifrao +' '+ Number(value).toFixed(3).moeda(3, '', lg.milhar, lg.decimal);

});

Vue.filter('number', function(value){
    var lg = JSON.parse(localStorage.getItem("__POLICE_SESSION_LG_"));
    return Number(value).toFixed(1).moeda(1, '', lg.milhar, lg.decimal).replace(',0', '');

});

Vue.filter('numberTwo', function(value){
    var lg = JSON.parse(localStorage.getItem("__POLICE_SESSION_LG_"));
    return Number(value).toFixed(2).moeda(2, '', lg.milhar, lg.decimal).replace(',00', '');

});

Vue.filter('zero', function(value){
    return value == null ?  '0' : value
});

Vue.filter('horimetro', function(value){

    if(value == null || value == ''){
        return '0,0'
    }

    var lg = JSON.parse(localStorage.getItem("__POLICE_SESSION_LG_"));
    return parseFloat(value).toFixed(1).moeda(1, '', lg.milhar, lg.decimal);

});

Vue.filter('horimetro2', function(value){

    if(value == null || value == ''){
        return '0,00'
    }

    var lg = JSON.parse(localStorage.getItem("__POLICE_SESSION_LG_"));
    return parseFloat(value).toFixed(2).moeda(2, '', lg.milhar, lg.decimal);

});

Vue.filter('horimetrona', function(value){

    if(value == null || value == 'N/A'){
        return 'N/A'
    } else if(value == 0){
        return '0,0'
    }

    var lg = JSON.parse(localStorage.getItem("__POLICE_SESSION_LG_"));
    return parseFloat(value).toFixed(2).moeda(2, '', lg.milhar, lg.decimal);

});

Vue.filter('horimetroSemDecimais', function(value){

    if(value == null || value == ''){
        return '0'
    }

    var lg = JSON.parse(localStorage.getItem("__POLICE_SESSION_LG_"));
    return parseFloat(value).toFixed(0).moeda(0, '', lg.milhar, lg.decimal);

});


Vue.filter('formataTempo', function(value){

    if(!_.isNil(value) && value != NaN && value != 'N/A' && value != ''){
        var vr = value.split(":")

        var hora = Number(vr[0]) < 10 ? "0" + Number(vr[0]) : vr[0]
        var minuto = Number(vr[1]) < 10 ? "0" + Number(vr[1]) : vr[1]

        return hora +':'+ minuto
    }

    return 'N/A'


})

Vue.filter('formataTempoPonto', function(value){

    if(!_.isNil(value) && value != NaN && value != 'N/A' && value != ''){
        var vr = value.split(".")

        var hora = Number(vr[0]) < 10 ? "0" + Number(vr[0]) : vr[0]
        var minuto = Number(vr[1]) < 10 ? "0" + Number(vr[1]) : vr[1]

        return hora +':'+ minuto
    }

    return 'N/A'


})


Vue.filter('formataDataSubstring', function(value){

    if(!_.isNil(value) && value != NaN && value != 'N/A'){

		if(Number(value)){
			return `${value.substring(4, 6)}/${value.substring(2, 4)}/${value.substring(0, 2)} ${value.substring(6, 8)}:${value.substring(8, 10)}`
		}

		return value
    }

    return 'N/A'


})

Vue.filter('numeroNegativo', (val) => {
	const numero = Number(val).toFixed(1)
	return numero >= 0 ? numero : 'N/A'
})

Vue.filter('cpf', (val) => {
	return (val || '')
            .toString()
            .padStart(11, '0')
            .replace(/\D/g, '')
            .replace(/^(\d{3})?(\d{3})?(\d{3})?(\d{2})?/, '$1.$2.$3-$4')
})

Vue.filter('cnpj', (val) => {
	return (val || '')
            .toString()
            .padStart(14, '0')
            .replace(/\D/g, '')
            .replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, '$1.$2.$3/$4-$5')
})

Vue.filter('cep', (val) => {
	return (val || '')
            .toString()
            .padStart(8, '0')
            .replace(/\D/g, '')
            .replace(/^(\d{5})?(\d{3})?/, '$1-$2')
})

Vue.filter('diasVencido', (val) => 
    (val > 0 ? val : _traducao('global', 'vencido').toUpperCase())
)

Vue.filter('upper', (val) => (val || '').toString().toUpperCase())

Vue.filter('verificaUnidade', (value = null) => {
    switch (value) {
        case 'SAFRAN_MM':
            return 'PADRÃO MOTOR'
        case 'AIRBUS_MSM_ALS':
            return 'PADRÃO CÉLULA'
        case 'DEFAULT':
            return 'PADRÃO'
        case 'AD_EASB_ASB':
            return 'AD / SB'
		case 'AIRBUS_AMM':
			return 'AIRBUS - AMM'
        default:
            return value;
    }
});

Vue.filter('arredondarV2', function(value){
    if(Number(value) == 0) {
        return 0
    }
    return parseFloat(value).toFixed(2)
})

Vue.filter('decimalParaHoras', function(value){
    const hours = Math.floor(value);
    const minutes = Math.round((value - hours) * 60);
    return `${hours}h${minutes}m`;
    
})

Vue.filter('decimalParaHorasComZero', function(value){
    const hours = Math.floor(value);
    const minutes = Math.round((value - hours) * 60);

    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    return `${formattedHours}h${formattedMinutes}m`;
    
})

Vue.filter('dataTempoDB', function(value){

    if(value == "" || value == null || _.isNil(value)){
        return ""
    }
    var dt = value.split(' ')[1]
    var ht = dt.split(':')
    return ht[0] +'h'+ht[1]+'min'
});

Vue.filter('tempoDB', function(value){

    if(value == "" || value == null || _.isNil(value)){
        return ""
    }
    var ht = value.split(':')
    return String(ht[0]).padStart(2, 0) +'h'+String(ht[1]).padStart(2, 0)+'min'
});